import { render, staticRenderFns } from "./ServiceEditForm.vue?vue&type=template&id=4f700d2a&"
import script from "./ServiceEditForm.vue?vue&type=script&lang=js&"
export * from "./ServiceEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports